import Vue from 'vue'

// 组件
import goodImage from '@/common/cms/modules/goods/template/widgets/good-image.vue'
import SkuHeader from './widgets/SkuHeader.vue'

// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  components: {
    goodImage,
    SkuHeader
  },
  props: {
    sku: {
      type: Object,
      default: () => ({})
    },
    skuIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    skuImg() {
      return this?.sku?.skuImg
    }
  }
})
